<template id="form_section">
    <div class="franchise-wrapper">
        <!-- New Design -->
        <FranchiseCommanDataVue OfficeName="Kolkata Office" OfficeNameAlternateLang="কলকাতায় স্বাগতম"
            OfficeAddress="Technico India P137 Hemanta Mukhopadhyay Sarani (Lake Terrace) Kolkata 700029"
            OfficeEmail="kolkata@aliff.in " OfficePhone="+91 8104356049" :source="58" />

        <section class="founder-section pb-xl-5 mb-5">

            <div class="container-fluid responsive_padding">
                <h2 class="main-heading-1-gradient text-center" data-aos="fade-down" data-aos-duration="600">
                    About Area Director
                </h2>

                <div class="row mt-5 align-items-start custom_director_section">
                    <div class="col-md-4 col-lg-4 responsive-img text-center" data-aos="fade-right"
                        data-aos-duration="600">

                        <img src="@/assets/imgs/franchise/kolkata.jpeg"
                            class="img-fluid border-20 custom_width_image" width="300" />
                    </div>
                    <div class="col-md-8 col-lg-8 text-left" data-aos="fade-left" data-aos-duration="600">
                        <h1 class="font-weight-bold responsive_margin_area"> Koyeli Dutt</h1>

                        <div class="row">
                            <div class="col-md-6">
                                <h5 class="new_sub_heading_color pt-2 font-weight-bold">Profile</h5>
                                <p class="main-content-1 pt-2 custom_font_sizing">
                                    Koyeli Dutt is the Managing Director of Technico (India) Pvt. Ltd., a leading fire
                                    protection company in Eastern India, and partners with Aptech for their Learning and
                                    Aviation verticals.

                                </p>
                            </div>

                            <!-- <div class="col-md-6">
                                <h5 class="new_sub_heading_color pt-2 font-weight-bold">Education</h5>
                                <p class="main-content-1 pt-2 custom_font_sizing">
                                    Experience in chemical, oil &amp; gas industries. He has worked in India, UAE and has travelled to.
                                </p>
                            </div> -->

                            <div class="col-md-6">
                                <h5 class="new_sub_heading_color pt-2 font-weight-bold">Professional Experience</h5>
                                <p class="main-content-1 pt-2 custom_font_sizing">
                                    Graduated in Fire Protection Engineering from the University of Maryland, USA in
                                    1995

                                </p>
                            </div>



                            <div class="col-md-6">
                                <h5 class="new_sub_heading_color pt-2 font-weight-bold">Achievements</h5>
                                <p class="main-content-1 pt-2 custom_font_sizing">

                                    Koyeli has held leadership roles in the Fire and Security Association of India, is a
                                    national board member, and leads the vocational training sub-committee at the Rotary
                                    Club of Calcutta Jadavpur </p>
                            </div>




                        </div>

                    </div>
                </div>
            </div>
        </section>

        <section class="container-fluid pb-xl-5 responsive_padding">
            <h2 class="main-heading-1-gradient text-center mb-5" data-aos="fade-down" data-aos-duration="600">
                Photographs
            </h2>
            <div class="team-member-cards">
                <slick ref="teamIntroSlider" :options="teamIntroSlider"
                    class="stu-card-slider green-slick-dots franchise-card-slider">
                    <img src="@/assets/imgs/franchise/bandra/1.jpg" class="custom_slider_img_height"
                        style="width: 80% !important" />
                    <img src="@/assets/imgs/franchise/bandra/2.jpg" class="custom_slider_img_height"
                        style="width: 80% !important" />
                    <img src="@/assets/imgs/franchise/bandra/3.jpg" class="custom_slider_img_height"
                        style="width: 80% !important" />
                    <img src="@/assets/imgs/franchise/bandra/4.jpg" class="custom_slider_img_height"
                        style="width: 80% !important" />
                </slick>
            </div>
        </section>

        <hr class="horizontal_line py-xl-1 mb-5" data-aos="fade-down" data-aos-duration="600" />

        <section class="container">
            <div class="row">
                <div class="col-12 mb-5">

                    <div class="w-100 d-flex justify-content-center">
                        <a href="#form_section" class="w-50 text-center">
                            <button class="main_btn_custom">Book Your Free Counseling Today</button>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import {
    stateOptions,
    courseOptions,
    specializationOptions,
    cityOptions,
} from "../partials/sefDetails";
import FranchiseCommanDataVue from "../partials/FranchiseCommanData.vue";
export default {
    components: {
        FranchiseCommanDataVue,
    },
    data() {
        return {
            establishedvalue: 2008,
            studentValue: 23,
            featured_universities: [],
            logoSlider: {
                infinite: true,
                slidesToShow: 6,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 1000,
                speed: 3000,
                pauseOnHover: true,
                cssEase: "linear",
                centerMode: true,
                centerPadding: "30px",
                adaptiveHeight: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                    },
                ],
            },
            teamIntroSlider: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                infinite: false,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 5000,
                // cssEase: "linear",
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            },

            stateOptions,
            courseOptions,
            specializationOptions,
            cityOptions,
            form: {
                name: "",
                email: "",
                mobileNumber: "",
                state: null,
                city: null,
            },
            destinationSlider: {
                infinite: true,
                rows: 2,
                slidesPerRow: 1,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 1000,
                cssEase: "ease",
                useTransform: true,
                speed: 1000,
                cssEase: "linear",
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1.5,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1.5,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: true,
                        },
                    },
                ],
            },
        };
    },

    methods: {},
};
</script>
<style>
.franchise-wrapper {
    margin-top: 120px;
}

.form_wrapper {
    padding: 20px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.fontWeightCustom {
    font-weight: 500;
}

.horizontal_line {
    width: 100%;
}

.city_img {
    position: absolute;
    top: 190px;
    right: 20px;
    z-index: -1;
    opacity: 0.2;
}

.city_img img {
    width: 90%;
}

.numbers_class {
    font-size: 30px;
    font-weight: bold;
}

.sub_heading_text {
    font-size: 30px;
}

.icons_custom {
    width: 25%;
    filter: drop-shadow(0 0 0.75rem black);
    margin-bottom: 10px;
}

.director_background {
    position: absolute;
    right: 0;
    top: 100px;
    opacity: 0.2;
    z-index: -1;
}

.custom_director_section {
    padding: 40px;
    background: #eaf4fe;
    border-radius: 10px;
    box-shadow: 0px 0px 0.806476px rgba(12, 26, 75, 0.1),
        3.22591px 4.83886px 12.9036px rgba(20, 37, 63, 0.12);
}

.responsive_padding {
    padding: 0 3rem;
}

.new_sub_heading_color {
    color: #ff3d00 !important;
}

@media (max-width: 767px) {
    .responsive_margin {
        margin-top: 10px;
    }

    .responsive_margin_area {
        margin-top: 30px;
    }

    .main_btn_custom {
        width: 100%;
        transform: scale(1) !important;
    }

    .director_background {
        position: absolute;
        top: 15px;
        opacity: 0.1;
        z-index: -1;
        widows: 100%;
        right: -133px;
    }

    .responsive_padding {
        padding: 0px;
    }

    .custom_overflow {
        overflow: hidden;
    }

    .city_img {
        position: absolute;
        top: 44%;
        right: -30%;
        z-index: -1;
        opacity: 0.2;
        /* width: 100%; */
    }
}

@media (min-width: 768px) and (max-width: 991px) {
    .custom_overflow {
        overflow: hidden;
    }

    .responsive_margin {
        margin-top: 10px;
    }

    .city_img {
        position: absolute;
        top: -15%;
        right: -30%;
        opacity: 0.2;
        width: 100%;
    }

    .director_background {
        position: absolute;
        right: 0;
        top: 0px;
        opacity: 0.1;
    }

    .icons_custom {
        width: 40%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/KolkataFranchisePage.vue